import { values } from 'lodash';
import { CALL_API, HTTP_METHODS } from '../middlewares/api.js';
import { externalEntity } from '../lib/schema.js';

const RETRIEVE_EXTERNAL_ENTITIES_REQUEST =
  'changesync/externalEntities/RETRIEVE_EXTERNAL_ENTITIES_REQUEST';
const RETRIEVE_EXTERNAL_ENTITIES_SUCCESS =
  'changesync/externalEntities/RETRIEVE_EXTERNAL_ENTITIES_SUCCESS';
const RETRIEVE_EXTERNAL_ENTITIES_FAILURE =
  'changesync/externalEntities/RETRIEVE_EXTERNAL_ENTITIES_FAILURE';

const initialState = {
  retrieveExternalEntities: {
    pending: false,
    success: false,
    error: null,
  },
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case RETRIEVE_EXTERNAL_ENTITIES_REQUEST:
      return {
        ...state,
        retrieveExternalEntities: {
          ...state.retrieveExternalEntities,
          pending: true,
          success: false,
          error: null,
        },
      };

    case RETRIEVE_EXTERNAL_ENTITIES_SUCCESS:
      return {
        ...state,
        retrieveExternalEntities: {
          ...state.retrieveExternalEntities,
          pending: false,
          success: true,
        },
      };
    case RETRIEVE_EXTERNAL_ENTITIES_FAILURE:
      return {
        ...state,
        retrieveExternalEntities: {
          ...state.retrieveExternalEntities,
          pending: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
};

// Action Creators

export const retrieveExternalEntities = (organizationId) => (dispatch) =>
  dispatch({
    [CALL_API]: {
      types: [
        RETRIEVE_EXTERNAL_ENTITIES_REQUEST,
        RETRIEVE_EXTERNAL_ENTITIES_SUCCESS,
        RETRIEVE_EXTERNAL_ENTITIES_FAILURE,
      ],
      endpoint: `organizations/${organizationId}/external_entities`,
      method: HTTP_METHODS.GET,
      schema: [externalEntity],
    },
  });

export const selectRetrieveExternalEntitiesState = (state) =>
  state.externalEntities.retrieveExternalEntities;

export const selectExternalEntities = (state) =>
  values(state.entities.externalEntities);
